// ReportModal.js
import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import {
  headingFonts,
  primaryButtonStyles,
  textFieldStyles,
} from "../../Styles/Styles";

const ReportModal = ({ open, onClose, onSubmit }) => {
  const [reportReason, setReportReason] = useState("");
  const [error, setError] = useState("");

  const handleReportSubmit = () => {
    if (!reportReason.trim()) {
      setError("Please provide a reason for reporting.");
      return;
    }
    onSubmit(reportReason);
    setReportReason(""); // Clear input field after submission
    onClose(); // Close modal after submission
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" mb={2} sx={{ ...headingFonts }}>
          Report Ad
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          label="Describe the issue"
          value={reportReason}
          onChange={(e) => setReportReason(e.target.value)}
          sx={{ ...textFieldStyles }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleReportSubmit}
          sx={{ mt: 2, ...primaryButtonStyles }}
        >
          Submit Report
        </Button>
      </Box>
    </Modal>
  );
};

export default ReportModal;
